// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pjaqP","delete":"styles_delete__2wtyU","update":"styles_update__3LUGH","add":"styles_add__vHM1C"};